module.exports = __webpack_public_path__ + "static/img/当心弧光.e86e2b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/当心弧光.png
// module id = yWcw
// module chunks = 1